import { SectionShell } from "@/components/design-system/SectionShell";
import { FONTS } from "@/components/design-system/palette";

const code = `// Set in design-system.css via @theme:
//   --font-display: 'Figtree', ui-sans-serif, system-ui, sans-serif;
//   --font-sans: 'Figtree', ui-sans-serif, system-ui, sans-serif;
//   --font-mono: 'IBM Plex Mono', ui-monospace, monospace;

<h1 className="font-display">Display headline</h1>
<p className="font-sans">Body paragraph.</p>
<span className="font-mono">PO-20418</span>`;

export function TypographySection() {
  return (
    <SectionShell
      id="typography"
      title="Typography"
      description={
        <>
          One family. <code>{FONTS.display}</code> carries display and body
          alike — weight and size do the hierarchy work. Code and reference
          numbers use <code>{FONTS.mono}</code>. Both load from Google Fonts
          via <code>&lt;link&gt;</code> tags in the app's HTML{" "}
          <code>&lt;head&gt;</code>.
        </>
      }
      whenToUse={
        <ul>
          <li>
            Use <code>font-display</code> for headings only. Headings already
            inherit it via base styles.
          </li>
          <li>
            Use <code>font-sans</code> for everything else — also already the
            default.
          </li>
          <li>
            Use <code>font-mono</code> for code, IDs, and reference numbers;{" "}
            <code>code</code> / <code>pre</code> get it automatically.
          </li>
        </ul>
      }
      whenNotToUse={
        <ul>
          <li>
            Don't import additional font families — propose adding to the
            system instead.
          </li>
          <li>Don't override <code>font-family</code> inline.</li>
        </ul>
      }
      preview={
        <div className="space-y-6">
          <div>
            <div className="mb-1 text-xs font-mono text-ink-muted">
              Display — {FONTS.display}
            </div>
            <div className="font-display text-4xl font-semibold text-ink-display">
              The quick brown fox jumps over the lazy dog
            </div>
          </div>
          <div>
            <div className="mb-1 text-xs font-mono text-ink-muted">
              Body — {FONTS.body}
            </div>
            <div className="font-sans text-base text-ink-body">
              The quick brown fox jumps over the lazy dog. 0123456789. The
              five boxing wizards jump quickly.
            </div>
          </div>
          <div>
            <div className="mb-1 text-xs font-mono text-ink-muted">
              Mono — {FONTS.mono}
            </div>
            <div className="font-mono text-base text-ink-body">
              PO-20418 · JE 1,402,657 · 0123456789
            </div>
          </div>
        </div>
      }
      code={code}
    />
  );
}
